export default __webpack_public_path__ + "static/media/thop-thanks.d6249d1a.png";